var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyItemsEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 177,
    viewBox: "0 0 195 177"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "MyItemsEmptyState_svg__a",
    width: "200%",
    height: "352.2%",
    x: "-50%",
    y: "-87.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 19,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.226735433 0 0 0 0 0.437054197 0 0 0 0 0.687818878 0 0 0 0.189056839 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "MyItemsEmptyState_svg__b",
    d: "M10.61.776l103.549.586c5.455.599 9.878 3.333 9.878 6.103V42.93c0 2.77-4.423 5.5-9.878 6.094L11.34 49.85C5.886 50.35 0 47.065 0 41.87V8.747C0 3.552 5.154.272 10.61.776z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 113.761)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.5 0h97.42c7.455 0 13.5 6.044 13.5 13.5v19.092c0 7.456-6.045 13.5-13.5 13.5H13.5c-7.456 0-13.5-6.044-13.5-13.5V13.5C0 6.044 6.044 0 13.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2DDEC",
    d: "M45.719 9.541h64.856a2.416 2.416 0 010 4.832H45.719a2.416 2.416 0 110-4.832zm0 8.808h46.493a2.416 2.416 0 110 4.831H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF3F9",
    d: "M45.719 31.56h15.097a2.415 2.415 0 110 4.831H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.32,
    cy: 17.146,
    fill: "#D2DDEC",
    rx: 11.311,
    ry: 11.274
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.506 21.329c.215.215.497.322.778.322.282 0 .564-.107.779-.322l5.504-5.505a1.1 1.1 0 00-1.556-1.557l-4.727 4.726-2.524-2.524a1.1 1.1 0 10-1.557 1.557l3.303 3.303z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 58.716)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.5 0h97.42c7.455 0 13.5 6.044 13.5 13.5v19.092c0 7.456-6.045 13.5-13.5 13.5H13.5c-7.456 0-13.5-6.044-13.5-13.5V13.5C0 6.044 6.044 0 13.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2DDEC",
    d: "M45.719 9.541h64.856a2.416 2.416 0 010 4.832H45.719a2.416 2.416 0 110-4.832zm0 8.808h46.493a2.416 2.416 0 110 4.831H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF3F9",
    d: "M45.719 31.56h15.097a2.415 2.415 0 110 4.831H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.32,
    cy: 17.146,
    fill: "#D2DDEC",
    rx: 11.311,
    ry: 11.274
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.506 21.329c.215.215.497.322.778.322.282 0 .564-.107.779-.322l5.504-5.505a1.1 1.1 0 00-1.556-1.557l-4.727 4.726-2.524-2.524a1.1 1.1 0 10-1.557 1.557l3.303 3.303z"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#MyItemsEmptyState_svg__a)",
    xlinkHref: "#MyItemsEmptyState_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#MyItemsEmptyState_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2DDEC",
    d: "M45.719 13.453h64.856a2.416 2.416 0 010 4.832H45.719a2.416 2.416 0 110-4.832zm0 8.807h46.493a2.416 2.416 0 010 4.832H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF3F9",
    d: "M45.719 35.472h15.097a2.415 2.415 0 110 4.831H45.719a2.415 2.415 0 110-4.831z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.44 11.251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.769,
    cy: 13.211,
    r: 13.211,
    fill: "#8DCC8B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M12.006 17.98a1.239 1.239 0 001.765 0l6.238-6.291a1.265 1.265 0 000-1.78 1.242 1.242 0 00-1.764 0l-5.356 5.402-2.862-2.885a1.24 1.24 0 00-1.764 0 1.267 1.267 0 000 1.78l3.743 3.774z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17 16h160v160H17z"
  }))));
}
export default SvgMyItemsEmptyState;